import IndexPage from '@pages/Index';
import AboutPage from '@pages/About';
// import TestsPage from '@pages/Tests';
// import TestsPdf from '@pages/TestsPdf';
import NotFound from '@pages/NotFound';

import { PathElement } from 'interfaces/route';

// const homePaths = process.env.DRUPAL
//   ? {
//     path: '*',
//   }
//   : {
//     languages: {
//       en: '/',
//       fr: '/fr',
//     },
//   };

const paths: PathElement[] = [
  {
    key: 'home',
    component: IndexPage,
    path: '*',
  },
  {
    key: 'about',
    component: AboutPage,
    languages: {
      en: '/about-us',
      fr: '/fr/about-us',
    },
  },
  // {
  //   key: 'tests',
  //   component: TestsPage,
  //   path: '/tests',
  // },
  // {
  //   key: 'test-pdf',
  //   component: TestsPdf,
  //   path: '/pdf',
  // },
  {
    key: 'notFound',
    component: NotFound,
    path: '*',
  },
];

export default paths;
